import { render, staticRenderFns } from "./index.vue?vue&type=template&id=683cf392&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgHome: require('/home/hadicod/source/components/svg/home.vue').default,SvgAddresscard: require('/home/hadicod/source/components/svg/addresscard.vue').default,SvgWifi: require('/home/hadicod/source/components/svg/wifi.vue').default,SvgWorker: require('/home/hadicod/source/components/svg/worker.vue').default,SvgWhatsapp: require('/home/hadicod/source/components/svg/whatsapp.vue').default,SvgLangs: require('/home/hadicod/source/components/svg/langs.vue').default})
